var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9177 24.6465H8.44362C7.53075 24.6459 6.65544 24.3082 6.00982 23.7076C5.3642 23.107 5.00102 22.2925 5 21.443C5.00204 20.0275 5.60719 18.6704 6.68277 17.6695C7.75835 16.6685 9.21656 16.1054 10.7377 16.1035L14.18 21.443L17.6223 16.1035C19.1435 16.1051 20.602 16.6681 21.6776 17.6691C22.7533 18.6702 23.3583 20.0274 23.36 21.443C23.359 22.2923 22.996 23.1066 22.3506 23.7072C21.7053 24.3077 20.8303 24.6455 19.9177 24.6465Z",
    fill: "#6D57DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3402 4C13.1856 4 12.0569 4.31862 11.0969 4.91557C10.1369 5.51252 9.38866 6.36098 8.94682 7.35367C8.50497 8.34636 8.38936 9.43869 8.61461 10.4925C8.83986 11.5464 9.39586 12.5144 10.2123 13.2741C11.0287 14.0339 12.0689 14.5513 13.2013 14.7609C14.3337 14.9706 15.5075 14.863 16.5742 14.4518C17.6409 14.0406 18.5526 13.3443 19.1941 12.4509C19.8355 11.5575 20.1779 10.5071 20.1779 9.43266C20.1779 7.99183 19.5629 6.61001 18.4681 5.59119C17.3733 4.57237 15.8884 4 14.3402 4Z",
    fill: "#6D57DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.869d2a067d682ed66fce91c3fc672b2c.svg";
export { ForwardRef as ReactComponent };